import { Vue, Component, Prop, Watch, Emit } from "vue-property-decorator";
import { Getter } from "vuex-class";

import Messages from '@/assets/ts/utils/Messages';

import EditableTable from '@/../bower_components/teknisavuecomponents/components/grids/EditableTable.vue';
import OcorDialog from '@/components/demonstrativo/OcorDialog/OcorDialog.vue';

import HttpRequest from "@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest";
import SnackbarUtils from "@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils";

import _ from 'lodash';
import User from '@/../bower_components/teknisavuecomponents/assets/interfaces/User';
import MarcacaoController from '@/assets/ts/controller/MarcacaoController';
import ExpectedError from '@/../bower_components/teknisavuecomponents/assets/utils/ExpectedError';
import Dictionary from "@/../bower_components/teknisavuecomponents/assets/interfaces/Dictionary";
import LocalizacaoController from "@/assets/ts/controller/LocalizacaoController";
import { ControleAcessoWrapper } from "@/assets/ts/controller/ControleAcessoController";

interface MarcacaoPopupModel {
  show: boolean;
  data: {
    dias: string[],
    nrVinculo: string,
  },
  changed: boolean,
  control: {
    open: (data: string) => null,
    close: () => null,
    changed: () => null,
  },
}

@Component({
  name: 'MarcacoesIndividuaisPopup',
  components: {
    EditableTable,
    OcorDialog,
  },
})
class MarcacoesIndividuaisPopup extends Vue {
  // #region [ PROPS ]
  @Prop({ default: () => {} })
  private value: MarcacaoPopupModel;
  // #endregion

  // #region [ DATA ]
  private isMarcacaoReadonlyOnEdit;
  // #endregion

  // #region [ STORE ]
  private get canUserEditCurrentPeriodo(): boolean {
    return this.$store.getters.canUserEditCurrentPeriodo;
  }

  private get user(): any {
    return this.$store.getters.user;
  }
  // #endregion

  // #region [ EVENTS ]
  @Emit('input')
  private emitChanges() {
    return this.value;
  }
  // #endregion

  // #region [ DATA ]
  private idsDias = [
    {
      name: 'FS',
      label: 'DS',
    },
    {
      name: 'FC',
      label: 'DC',
    },
    {
      name: 'DC',
      label: 'DC',
    },
    {
      name: 'FA',
      label: 'DA',
    },
  ];

  private availableGridColumns: any = {
    NRMARCACAOPONTO: {
      text: 'Nr. Marcação',
      value: 'NRMARCACAOPONTO',
      align: 'left',
      readonly: true,
    },
    IDDIAOCORRENCIA: {
      text: 'ID',
      value: 'IDDIAOCORRENCIA',
      type: 'select',
      align: 'left',
      readonly: true,
      descriptionField: 'label',
      valueField: 'name',
      items: this.idsDias,
    },
    DTAPURACAOSITUFREQ: {
      text: 'Data',
      value: 'DTAPURACAOSITUFREQ',
      align: 'left',
      readonly: true,
    },
    HORA_MINUTO: {
      text: 'Horário',
      value: 'HORA_MINUTO',
      align: 'left',
      readonly: true,
    },
  };

  private modes: any = {
    singleDateMode: {
      columns: [
        this.availableGridColumns.NRMARCACAOPONTO,
        this.availableGridColumns.IDDIAOCORRENCIA,
        this.availableGridColumns.HORA_MINUTO,
      ],
    },
    multipleDateMode: {
      columns: [
        this.availableGridColumns.NRMARCACAOPONTO,
        this.availableGridColumns.IDDIAOCORRENCIA,
        this.availableGridColumns.DTAPURACAOSITUFREQ,
        this.availableGridColumns.HORA_MINUTO,
      ],
    },
  };

  private screenDialog: any = {
    close: this.close,
    open: this.open,
    title: {
      default: {
        base: 'Marcações do Dia - @DATA@',
        mnemonic: '@DATA@',
      },
      multipleDays: {
        base: 'Marcações dos Dias',
      },
      text: '',
      build: this.buildCardText,
    },
    changed: this.popUpManipulated,
  };

  private loadingStatus = {
    reload: false,
    delete: false,
  };

  private gridRows = [];

  private map: google.maps.Map<Element> = null;

  private marcacoesMarkersMap: Dictionary<google.maps.Marker> = {};

  private enderecoData = {
    endereco: null as string,
    loading: false,
    error: false,
    noLocalization: false,
    nrMarcacao: null as string,
  };
  // #endregion

  // #region [ COMPUTED ]
  public get loading(): boolean {
    const loadingStatusKeys = Object.values(this.loadingStatus);

    const isLoading = loadingStatusKeys.reduce((accumulator, status) => {
      return accumulator || status;
    }, false);

    return isLoading;
  }

  private get grid() {
    return {
      actions: [
        {
          name: 'delete',
          label: 'Excluir',
          icon: 'mdi-delete',
          onClick: ControleAcessoWrapper.deletar(this.removeMarcacao),
          mode: 'edit',
          condition: this.isDeleteVisible,
        },
      ],
      columns: [
        {
          text: 'Nr. Marcação',
          value: 'NRMARCACAOPONTO',
          align: 'left',
          readonly: true,
        },
        {
          text: 'Data',
          value: 'DTAPURACAOSITUFREQ',
          align: 'left',
          readonly: true,
        },
        {
          text: 'Hora-minuto',
          value: 'HORA_MINUTO',
          align: 'left',
          readonly: true,
        },
      ],
      defaultRow: {},
      updateFooterRowValue: {},
      tableOnEnter: {},
      tableReadonly: true,
      toolbarActions: [
        {
          name: 'reload',
          label: 'Atualizar',
          icon: 'mdi-refresh',
          onClick: this.reloadGrid,
        },
      ],
      dense: true,
    };
  };

  public get enderecoDesc(): { text: string, color: string } {
    const desc = {
      text: '-',
      color: '#0256ab',
    };

    if (this.enderecoData.nrMarcacao === null) {
      desc.text = 'Clique em uma marcação para ver seu endereço.';
      desc.color = '#0256ab';
    } else if (this.enderecoData.loading) {
      desc.text = 'Carregando...';
      desc.color = '#0256ab';
    } else if (this.enderecoData.error) {
      desc.text = 'Não foi possível carregar o endereço!';
      desc.color = 'red';
    } else if (this.enderecoData.noLocalization) {
      desc.text = 'A marcação selecionada não possui localizacão!';
      desc.color = 'orange';
    } else {
      desc.text = this.enderecoData.endereco;
      desc.color = '#0256ab';
    }

    return desc;
  }
  // #endregion

  // #region [ LIFECYCLE ]
  // Bind properties to model property
  private created() {
    this.value.control = { ...this.screenDialog };

    this.emitChanges();
  }
  // #endregion

  // #region [ WATCHERS ]
  @Watch('value.show', { immediate: true })
  private valueOnChange() {
    if (this.value.show) {
      this.onShow();
    }
  }
  // #endregion

  // #region [ METHODS ]
  private async removeMarcacao(marcacaoRow: any) {
    const nrVinculo = this.value.data.nrVinculo;
    const nrMarcacao: string = marcacaoRow.NRMARCACAOPONTO;

    this.loadingStatus.delete = true;

    try {
      await MarcacaoController.removeMarcacao(nrVinculo, nrMarcacao, false);
    } catch (err) {
      const e = err as any;
      const message = e.response.data.error;

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err; 
    } finally {
      this.loadingStatus.delete = false;
    }

    SnackbarUtils.showMessage(Messages.MARCACAO_ROW_DELETED);
    this.screenDialog.changed();

    this.reloadGrid();
  }

  private onShow() {
    this.value.changed = false;
    this.reloadGrid();
    this.emitChanges();

    this.resetMapData();

    setTimeout(() => {
      this.initMap();
    });
  }

  private close() {
    this.value.show = false;
    this.emitChanges();
  }

  private resetMapData(): void {
    // Tira as marcações do mapa
    Object.values(this.marcacoesMarkersMap).forEach((marker) => {
      marker.setMap(null);
    });

    this.enderecoData.nrMarcacao = null;
    this.marcacoesMarkersMap = {};
  }

  private open(data: string | string[] = null) {
    if (data) {
      this.value.data.dias = !Array.isArray(data) ? [data] : data;
      this.screenDialog.title.build();
    }

    this.value.show = true;
    this.emitChanges();
  }

  private buildCardText() {
    const titleMode = this.getTitleMode();
    this.screenDialog.title.text = titleMode.mnemonic ? titleMode.base.replace(titleMode.mnemonic, this.getCurrentDate()) : titleMode.base;
  }

  private popUpManipulated() {
    this.value.changed = true;
    this.emitChanges();
  }

  private isMultipleDateMode() {
    return Array.isArray(this.value.data.dias) ? this.value.data.dias.length > 1 : true;
  }

  private getCurrentDate() {
    return this.isMultipleDateMode() ? this.value.data.dias : (this.value.data.dias.length === 0 ? '' : this.value.data.dias[0]);
  }

  private getTitleMode() {
    return this.isMultipleDateMode() ? this.screenDialog.title.multipleDays : this.screenDialog.title.default;
  }

  private getCurrentMode() {
    return this.isMultipleDateMode() ? this.modes.multipleDateMode : this.modes.singleDateMode;
  }

  private async reloadGrid() {
    const { nrVinculo, dias } = this.value.data;

    this.loadingStatus.reload = true;

    try {
      const marcacoes =
        await MarcacaoController.getDetalheAcompanhamento(nrVinculo, dias, false);

      this.gridRows = marcacoes;

      this.resetMapData();
      this.showMarcacoesOnMap();
    } catch (err) {
      if (err instanceof ExpectedError) {
        SnackbarUtils.showMessage(err.message);
      }

      throw err;
    } finally {
      this.loadingStatus.reload = false;
    }
  }

  public onTableRowClick(row: any): void {
    const hasLocalization = this.marcacaoHasLocalization(row);

    this.centerMarcacao(row);

    this.enderecoData.nrMarcacao = row.NRMARCACAOPONTO;
    this.enderecoData.noLocalization = !hasLocalization;

    if (hasLocalization) {
      this.getMarcacaoEndereco(row);
    }
  }

  private async initMap() {
    const mapElement: Element = this.$refs.gmap as any;

    if (!mapElement) {
      return;
    }

    const defaultPosition = {
      lat: -19.9358472,
      lng: -43.9352257,
    };

    this.map = new google.maps.Map(mapElement, {
      center: defaultPosition,
      zoom: 1,
    });


    // if (radius) {
    //   const radiusCircle = new google.maps.Circle({
    //     center: companyLocation,
    //     radius,
    //     map,
    //     fillColor: '#42A8E682',
    //     strokeColor: '#245675',
    //     strokeWeight: 1,
    //   });
    // }

    // const bounds = new google.maps.LatLngBounds();
    // bounds.extend(companyMarker.getPosition());
    // bounds.extend(userMarker.getPosition());

    // map.fitBounds(bounds);
  }

  private showMarcacoesOnMap(): void {
    const bounds = new google.maps.LatLngBounds();

    const marcacoesWithLocalization = this.gridRows.filter(row => this.marcacaoHasLocalization(row));

    marcacoesWithLocalization.forEach((marcacao) => {
      const position = {
        lat: parseFloat(marcacao.DSLATITUDE),
        lng: parseFloat(marcacao.DSLONGITUDE),
      };

      if (this.marcacaoHasLocalization(marcacao)) {
        const marcacaoMarker = new google.maps.Marker({
          position,
          map: this.map,
          title: `Marcação ${marcacao.NRMARCACAOPONTO}`,
        });

        this.marcacoesMarkersMap[marcacao.NRMARCACAOPONTO] = marcacaoMarker;
        bounds.extend(marcacaoMarker.getPosition());
      }
    });

    if (marcacoesWithLocalization.length >= 1) {
      this.map.fitBounds(bounds);

      const maxZoom = 15;
      const zoom = Math.min(this.map.getZoom(), maxZoom);

      this.map.setZoom(zoom);
    }
  }

  private async getMarcacaoEndereco(row: any): Promise<void> {
    if (!this.marcacaoHasLocalization(row)) {
      return;
    }

    this.enderecoData.loading = true;
    this.enderecoData.error = false;

    try {
      this.enderecoData.endereco = await LocalizacaoController.getAddressLocation(
        row.DSLATITUDE,
        row.DSLONGITUDE,
      );
    } catch (err) {
      this.enderecoData.error = true;
    } finally {
      this.enderecoData.loading = false;
    }
  }

  private marcacaoHasLocalization(row: any): boolean {
    return row.DSLATITUDE !== null && row.DSLONGITUDE !== null;
  }

  private centerMarcacao(row: any) {
    const marker = this.getMarkerByMarcacao(row);

    if (marker) {
      this.map.setCenter(marker.getPosition());
      this.map.setZoom(15);
    }
  }

  private highlightMarcacao(row: any): void {
    const marker = this.getMarkerByMarcacao(row);

    if (!marker) {
      return;
    }

    const allMarkers = Object.values(this.marcacoesMarkersMap);

    allMarkers.forEach((marker) => {
      marker.setZIndex(0);
    });

    marker.setZIndex(1);
    marker.setAnimation(google.maps.Animation.BOUNCE);
  }

  private getMarkerByMarcacao(row: any): google.maps.Marker {
    const marker = this.marcacoesMarkersMap[row.NRMARCACAOPONTO];
    return marker;
  }

  public rowStyleFunction(row: any) {
    switch (row.ID_STATUS_MARC) {
      case 'P':
        return `color: lightgrey;`;
      case 'N':
        return `color: red;`;
    }
    
    if (row.COLETOR_GESTOR) {
      return 'color: blue;';
    }

    if (row.COLETOR_AUTOMATICO) {
      return 'color: darkgoldenrod;';
    }

    return null;
  }

  private isRowNotReadonly(row: any) {
    return this.user.idbloqueioedicaomarc
      ? row.ID_EDITABLE_PG == 'S'
      : true;
  }

  private isDeleteVisible(row: any) {
    return this.canUserEditCurrentPeriodo && this.isRowNotReadonly(row);
  }
  // #endregion
}

export default MarcacoesIndividuaisPopup;

